module.exports = __webpack_public_path__ + "media/images/front/about/ttllogo-1b19f0815f849679cf6ab21e7d82ab6f.png";